import React from "react";

import styles from "./separator.module.scss";

const Separator = () => <hr className={styles.wrap} />;

export default Separator;
